var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ModalContent', {
    attrs: {
      "stitch": "",
      "help-content-id": "popup-customer-".concat(_vm.current_entity_profile)
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$translate("title")))]), _vm.catalog !== null ? _c('template', {
    slot: "content"
  }, [!_vm.ready ? [_c('Loading', {
    attrs: {
      "absolute": false
    }
  })] : [_c('div', {
    staticClass: "px-4"
  }, [_c('h5', {
    staticClass: "stitch-modal__title"
  }, [_vm._v(" " + _vm._s(_vm.$translate("catalogsTitle")) + " ")]), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$translate('catalogsInstructions').replace('{catalog}', _vm.catalog.name))
    }
  })]), _c('Table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.customers,
      "rows-count": _vm.customers_count,
      "loading": _vm.customers_loading,
      "filters": _vm.customers_filters,
      "filters-conf": _vm.filtersConf,
      "remote": true,
      "show-select": true,
      "item-key": 'id',
      "item-value": 'id',
      "value": _vm.assignedCustomers,
      "items-per-page": _vm.customers_filters.limit
    },
    on: {
      "on-filters-change": _vm.onFiltersChange,
      "on-row-click": _vm.onRowClick,
      "on-row-selected": _vm.onRowSelected,
      "on-row-deselected": _vm.onRowDeselected,
      "toggle-select-all": _vm.toggleSelectAll
    },
    scopedSlots: _vm._u([{
      key: "name",
      fn: function fn(props) {
        return [_c('CustomerName', {
          attrs: {
            "link": false,
            "customer": props.row
          }
        })];
      }
    }], null, false, 2689430695)
  })]], 2) : _vm._e(), _c('template', {
    slot: "bottom"
  }, [_c('div', {
    staticClass: "d-flex justify-center justify-space-between align-center"
  }, [_c('span', {
    staticClass: "link",
    on: {
      "click": _vm.assignNoCustomer
    }
  }, [_vm._v(_vm._s(_vm.$translate("assignNoCustomer")))]), _vm._v("  -  "), _c('span', {
    staticClass: "link",
    on: {
      "click": _vm.assignAllCustomers
    }
  }, [_vm._v(_vm._s(_vm.$translate("assignAllCustomers")) + " ")])]), _c('v-spacer'), _c('v-btn', {
    staticClass: "my-2 my-sm-4 w-100 w-sm-auto",
    on: {
      "click": _vm.hideModal
    }
  }, [_vm._v(" " + _vm._s(_vm.$translate("buttons.cancel")) + " ")]), _c('v-btn', {
    staticClass: "primary my-2 my-sm-4 w-100 w-sm-auto ml-sm-3",
    attrs: {
      "disabled": _vm.assigning_catalog
    },
    on: {
      "click": _vm.assignCatalogClicked
    }
  }, [_vm._v(" " + _vm._s(_vm.saveText) + " ")])], 1)], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }